import { computed, inject, Injectable, Signal } from '@angular/core';
import {
  CollectionStore2,
  NestedStore2Feature,
  ReadonlyRepositoryCollectionStore2,
  RepositoryCollectionState,
} from '@softline/core';
import { Kopfau, KopfauWithMetadata, PmsTaetigkeit } from '../types/kopfau';
import { AuftragService } from '../services/auftragService';

@Injectable()
export class AuftragStoreAddon<T> extends NestedStore2Feature<any> {
  collectionStore = inject(CollectionStore2<Kopfau>);
  readonly auftragService = inject(AuftragService);

  constructor() {
    super();
  }

  nonFinishedAuftraege: Signal<KopfauWithMetadata[]> = computed(() => {
    const state = this.collectionStore.state();
    const ids = state?.ids;
    const entities = state?.dict ?? {};

    // console.log('State: ', state);

    return (
      ids
        .map((id) => {
          const entity = entities[id];

          return {
            kopfau: entity,
            metadata: { updating: false },
          };
        })
        .filter((o): o is KopfauWithMetadata => !!o?.kopfau)
        .filter(({ kopfau }) => kopfau?.status !== 'ABGESCHLOSSEN') ?? []
    );
  });

  finishedAuftraege: Signal<Kopfau[]> = computed(() => {
    return this.collectionStore.all().filter((o) => o.status === 'ABGESCHLOSSEN');
  });

  getDefaultState(): any {
    return {};
  }

  loadPicture(id: string) {
    return this.auftragService.loadPicture(id);
  }

  async changeStatus(kopfau: Kopfau, taetigkeit?: PmsTaetigkeit) {
    await this.auftragService.changeStatus(kopfau, taetigkeit);

    this.collectionStore.patch({
      id: kopfau.id,
      changes: {
        status: kopfau.status === 'PAUSIERT' ? 'GESTARTET' : 'PAUSIERT',
      },
    });
  }
}
